import { useContext } from 'react';
import reactReferer from 'react-referer';
import { useNavigate } from 'react-router-dom';
import { constants } from '../constants';
import { LocationHistoryContext } from '../provider/LocationHistoryProvider';

const useMyMApi = (screenId) => {
  const navigate = useNavigate();
  const prevUrl = useContext(LocationHistoryContext);

  const createApiRequestParameter = (method, contentType, customParam) => {
    const requestParameter = {
      method: method ?? 'GET',
      credentials: 'include',
    }

    if (customParam) {
      if (customParam instanceof FormData) {
        requestParameter.body = customParam;
      } else {
        requestParameter.body = JSON.stringify({ ...customParam });
      }
    }

    // リクエストヘッダ部作成
    const headers = {
      accept: '*/*',
    };
    headers[constants.HttpOriginalHeaderKey.PrevPage] = prevUrl?.current ?? reactReferer.referer();
    if (contentType) {
      headers['content-type'] = contentType;
    }
    if (screenId) {
      headers[constants.HttpOriginalHeaderKey.ScreenId] = screenId;
    }
    const debugUserKey = sessionStorage.getItem(constants.HttpStorageItemKey.DebugUserSsoKey);
    if (process.env.REACT_APP_ALLOW_SELECT_DEBUG_USER === '1' && debugUserKey) {
      headers[constants.HttpOriginalHeaderKey.DebugUserSsoKey] = debugUserKey;
    }
    requestParameter.headers = headers;
    return requestParameter;
  }

  const requestFailed = (response, failedCallback) => {
    switch (response.status) {
      case 400:
        response.json().then((json) => {
          if (json.HandledRequest || json.errors) {
            if (json.errors) {
              // ApiValidationError時
              alert(Object.values(json.errors).join('\n'));
            } else {
              // ビジネスエラー時
              if (json.Message !== "") {
                // 2024.5.8 MyMine Version1.5対応 Add Start
                if (json.ColumnName)
                  alert(`[${json.ColumnName}]${json.Message}`)
                else
                // 2024.5.8 MyMine Version1.5対応 Add End
                  alert(json.Message);
              }
            }
            failedCallback && failedCallback(json);

          } else {
            failedCallback && failedCallback(json);
            navigate('/MyM999');
          }
        });
        break;
      case 401:
      case 403:
        response.text().then((error) => {
          failedCallback && failedCallback();
          navigate('/MyM999', { state: { message: error } });
        });
        break;

      default:
        failedCallback && failedCallback();
        navigate('/MyM999');
        break;
    }
  }

  // 2024.9.16 MyMine Version2.0対応 Add Start
  /**
   * APIリクエストメイン処理
   * @param {any} url
   * @param {any} requestParameter
   * @param {any} responseCallback
   */
  const requestMain = (url, requestParameter, responseCallback) => {
    fetch(url, requestParameter).then(responseCallback);
  }
  // 2024.9.16 MyMine Version2.0対応 Add End

  return {

    /**
     * ファイルダウンロード
     * @param {any} url
     * @param {any} successCallback
     * @param {any} failedCallback
     * @param {any} customParam
     */
    download: (url, successCallback, failedCallback, customParam) => {
      // 2024.9.16 MyMine Version2.0対応 Modify Start
      const requestParameter = createApiRequestParameter('GET', 'application/json;charset=UTF-8', customParam);
      requestMain(
        url,
        requestParameter,
        (response) => {
          if (response.ok) {
            response.blob().then((blob) => {
              const disposition = response.headers.get('Content-Disposition');
              if (disposition && disposition.indexOf('attachment') !== -1) {
                var fileNameMatches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
                if (fileNameMatches != null && fileNameMatches[1]) {
                  const fileName = decodeURIComponent(fileNameMatches[1].replace(/['"]/g, ''));
                  const a = document.createElement('a');
                  a.href = window.URL.createObjectURL(blob);
                  a.download = fileName;
                  a.click();
                  successCallback();
                }
              }
            });

          } else {
            requestFailed(response, failedCallback)
          }
        });
      // 2024.9.16 MyMine Version2.0対応 Modify End
    },

    /**
     * JSONリクエスト
     * @param {any} url
     * @param {any} method
     * @param {any} successCallback
     * @param {any} failedCallback
     * @param {any} customParam
     */
    requestJson: (url, method, successCallback, failedCallback, customParam) => {
      // 2024.9.16 MyMine Version2.0対応 Modify Start
      const requestParameter = createApiRequestParameter(method, 'application/json;charset=UTF-8', customParam);
      requestMain(
        url,
        requestParameter,
        (response) => {
          if (response.ok) {
            successCallback &&
              response.json().then((json) => {
                successCallback(json);
              });
          } else {
            requestFailed(response, failedCallback)
          }
        });
      // 2024.9.16 MyMine Version2.0対応 Modify End
    },

    /**
     * Formリクエスト
     * @param {any} url
     * @param {any} method
     * @param {any} successCallback
     * @param {any} failedCallback
     * @param {any} formData
     */
    requestForm: (url, method, successCallback, failedCallback, formData) => {
      // 2024.9.16 MyMine Version2.0対応 Modify Start
      const requestParameter = createApiRequestParameter(method, null, formData);
      requestMain(
        url,
        requestParameter,
        (response) => {
          if (response.ok) {
            response.json().then((json) => {
              successCallback(json);
            });
          } else {
            requestFailed(response, failedCallback)
          }
        });
      // 2024.9.16 MyMine Version2.0対応 Modify End
    },
  }
}
export default useMyMApi;